import { Controller } from "@hotwired/stimulus"

// The range control on the send monitor's sales chart.
//
// DELIBERATELY THIN. All five ranges are already drawn, server-side, into the
// page -- see SendMonitorSalesChartHelper for why (the page costs ~20s to load,
// so a control that navigated would make "let me see the last three months" a
// twenty-second question, and every range is a suffix of one series that has
// already been fetched).
//
// So this plots nothing and computes nothing. Putting the geometry in here
// would mean a second implementation of it in a second language, free to drift
// from the Ruby one the specs hold. All it does is decide which <figure> is
// visible and which button looks pressed.
export default class extends Controller {
  static values = { selected: String }

  connect() {
    // The markup ships every chart `hidden`, so that a slow load shows nothing
    // rather than five charts stacked on top of each other. Nothing is visible
    // until this runs.
    this.show(this.selectedValue)
  }

  select(event) {
    this.show(event.params.key)
  }

  show(key) {
    const charts = this.element.querySelectorAll("[data-range]")
    // Fall back to whatever is first rather than leaving the panel blank: a
    // stale or hand-edited key must not be able to hide the whole chart.
    const known = Array.from(charts).some((el) => el.dataset.range === key)
    const wanted = known ? key : this.element.querySelector("figure[data-range]")?.dataset.range

    charts.forEach((el) => {
      const active = el.dataset.range === wanted

      if (el.tagName === "BUTTON") {
        el.classList.toggle("sales__range--on", active)
        // Pressed state for anyone not reading the colour.
        el.setAttribute("aria-pressed", active ? "true" : "false")
      } else {
        el.hidden = !active
      }
    })

    this.selectedValue = wanted
  }
}
